/**
 * Endpoints de catálogos read-only — productos, clientes.
 */

import { GetProductosResponse, type Producto } from '@/api/contracts/productos';
import { GetClientesResponse, type Cliente } from '@/api/contracts/clientes';
import { getDb } from '@/api/mock/db';

const MOCK_LATENCY_MS = 80;
function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/productos */
export async function getProductos(): Promise<Producto[]> {
  await delay(MOCK_LATENCY_MS);
  return GetProductosResponse.parse(getDb().productos);
}

/** GET /api/clientes */
export async function getClientes(): Promise<Cliente[]> {
  await delay(MOCK_LATENCY_MS);
  return GetClientesResponse.parse(getDb().clientes);
}
